import { render, staticRenderFns } from "./swiperVenter.vue?vue&type=template&id=5b309316&scoped=true&"
import script from "./swiperVenter.vue?vue&type=script&lang=js&"
export * from "./swiperVenter.vue?vue&type=script&lang=js&"
import style0 from "./swiperVenter.vue?vue&type=style&index=0&id=5b309316&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b309316",
  null
  
)

export default component.exports